import { Record } from "@skinsoft/types";
import { dbCacheUp } from "../dexie/cache-up";
import { OfflineDataUpdateCacher } from "../offline-data-update-cacher";

export class AuditRecordOfflineDataUpdateCacher extends OfflineDataUpdateCacher<Record> {
    constructor() {
        super(dbCacheUp.auditRecord)
    }
}